import React, { useEffect } from 'react';
import { throttle } from 'lodash-es';

type CustomScrollBarTypes = {
  imageCount: number;
  videoQty?: number;
  sliderContainer: React.MutableRefObject<HTMLElement | null>;
  viewPortWidth: number;
};

function CustomScrollBar({ imageCount, videoQty = 0, sliderContainer, viewPortWidth }: CustomScrollBarTypes) {
  const handleScrollBar = () => {
    if (sliderContainer.current) {
      const scrollIndicator: HTMLElement | null = document.querySelector('.scroll-thumb');
      const { scrollLeft } = sliderContainer.current;
      const scrollPercentage: number = (scrollLeft / viewPortWidth) * 100;
      if (scrollPercentage >= 0 && scrollIndicator) {
        scrollIndicator.style.transform = `translate(${scrollPercentage}%)`;
      }
    }
  };

  const throttledHandleScrollBar = throttle(handleScrollBar, 150);

  useEffect(() => {
    const slideShowContainer = sliderContainer.current;
    if (slideShowContainer != null) {
      slideShowContainer.addEventListener('scroll', () => {
        throttledHandleScrollBar();
      });
      return () =>
        slideShowContainer.removeEventListener('scroll', () => {
          throttledHandleScrollBar();
        });
    }
  }, [viewPortWidth, sliderContainer, throttledHandleScrollBar]);

  const trackWidth = `${100 / (imageCount + videoQty)}%`;

  return (
    <div className="scroll-track">
      <div style={{ width: `${trackWidth}` }} className="scroll-thumb" />
    </div>
  );
}

export default CustomScrollBar;
